import React from 'react';
import { observer, inject } from 'mobx-react';
import ButtonSpinner from '../ButtonSpinner';
import LoadingSpinner from '../LoadingSpinner';
import { Modal, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap';
import TinyMCE from 'react-tinymce';

@inject('announcementStore')
@observer
export default class AddAnnouncement extends React.Component {
    componentDidMount() {
    }
    render() {
        if (!this.props.announcementStore.LoadingAnnouncementForUpdate) {
            return (
                <Modal show={this.props.announcementStore.ShowAddAnnouncement} bsSize="lg"  >
                    <Modal.Header>Add/Edit Announcement</Modal.Header>
                    <Modal.Body>
                        <FormGroup controlId="Content" >
                            <TinyMCE
                                content={this.props.announcementStore.AddAnnouncementRequest.Content}
                                config={{
                                    plugins: 'autolink link image advcode table lists print preview textcolor',
                                    toolbar: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat'
                                }}
                                onChange={(e) => { this.props.announcementStore.UpdateAddAnnouncementRequestProperty("Content", e.target.getContent()) }}
                            />
                        </FormGroup>
                        <FormGroup controlId="Version" >
                            <ControlLabel>Announcement Date</ControlLabel>
                            <FormControl type="text" value={this.props.announcementStore.AddAnnouncementRequest.AnnouncementDate} name="AnnouncementDate" placeholder="Enter data announcement starts" onChange={(e) => { this.props.announcementStore.UpdateAddAnnouncementRequestProperty(e.target.name, e.target.value) }} />
                        </FormGroup>
                        <FormGroup controlId="Category" >
                            <ControlLabel>Expires On</ControlLabel>
                            <FormControl type="text" value={this.props.announcementStore.AddAnnouncementRequest.ExpiresOn} name="ExpiresOn" placeholder="Enter ExpiryDate" onChange={(e) => { this.props.announcementStore.UpdateAddAnnouncementRequestProperty(e.target.name, e.target.value) }} />
                        </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => { this.props.announcementStore.ToggleAddAnnouncementModal(); }}>Close</Button>
                        <Button onClick={() => { this.props.announcementStore.AddAnnouncement(); }}>Save <ButtonSpinner IsLoading={this.props.announcementStore.IsAddingAnnouncement} /> </Button>
                    </Modal.Footer>
                </Modal>
            );
        }
        else {
            return (<LoadingSpinner />);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Announcements/AddAnnouncement.js